import React from 'react';
import { ModalForLanguageInputs } from './ModalForLanguageInputs';
import { ModalReset } from './ModalReset';

export function ModalsWrapper(): JSX.Element {
	return (
		<>
			<ModalReset />
			<ModalForLanguageInputs />
		</>
	);
}
